module.exports = __webpack_public_path__ + "static/img/img-rate-30@3x.5c922da.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/promotion/img-rate-30@3x.png
// module id = 6OTW
// module chunks = 18